import styled from 'styled-components';

const StyledBakground = styled.div`
  * {
    box-sizing: border-box;
  }

  :root {
    --color-primary: #3192e5;
  }

  display: grid;
  place-items: center;
  margin: 0;
  height: 100vh;
  padding: 0 24px;
  background-image: url('bg.svg');
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgb(139, 138, 136);
  font-family: 'Poppins', sans-serif;
  color: #f9f9f9;
`;

export default StyledBakground;
